import { StyledInput } from './StyledComponents';
import { BUTTON_SIZES, IconButton, IconRemove, IconAdd } from 'cdk-radial';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

export const AllowedIpRangeComponent = ({
  allowedIPRange,
  setAllowedIPRangeModel,
  label,
  isDisabled
}: any) => {
  const {t} = useTranslation();

  const addRow = () => {
    const newRow = {
      id: uuidv4(),
      begin: '',
      end: '',
      hasBeginError:false,
      hasEndError:false,
      beginErrorMsg:'',
      endErrorMsg:''
    };
    setAllowedIPRangeModel([...(allowedIPRange || []), newRow]);
  };

  const removeRow = (id: string) => {
    const updatedList = allowedIPRange.filter((row: any) => row.id !== id);
    setAllowedIPRangeModel(updatedList);
  };

  const handleIPInputChange = (
    row: any,
    id: string,
    field: "begin" | "end",
    value: string
  ) => {
    setAllowedIPRangeModel(
      allowedIPRange.map((r: any) =>
        r.id === id ? { ...r, [field]: value } : r
      )
    );
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          marginTop: '10px',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            fontFamily: 'Roboto,sans-serif',
            fontWeight: 400,
            fontSize: '14px',
            marginLeft: '8px',
            marginTop: '5px',
          }}
        >
           {label}
        </div>
        <div>
          { 
          !isDisabled 
            && <IconButton
            icon={<IconAdd />}
            size={BUTTON_SIZES.SMALL}
            onClick={addRow}
            data-testid="add-row-button"
            text="Button"
          />
        }
        </div>
      </div>

      <div style={{ marginTop: '-5px' }}>
        <table style={{ width: '380px' }}>
          <tbody>
            {allowedIPRange?.map((row: any, index: number) => (
              <tr key={row.id} style={{ height: '60px' }}>
                <td style={{ width: '185px' }}>
                  <div>
                    <StyledInput
                      dataTestId={`begin-${row.id}`}
                      id={`begin-${row.id}`}
                      inputDivider="left"
                      label={t('dealer-admin.ip-access.label.ipAddress')}
                      name={'begin'}
                      placeholder={t('dealer-admin.ip-access.label.startingIP')}
                      onChange={(e: any) =>
                        handleIPInputChange(row, row.id, 'begin', e.target.value)
                      }
                      value={row.begin || ''}
                      maxLength={15}
                      isRequired={true}
                      hasCharacterCount={true}
                      enableCustomValidation
                      hasError={row.hasBeginError}
                      errorMessage={row.beginErrorMsg}
                      isDisabled={isDisabled}
                    />
                  </div>
                </td>
                <td style={{ width: '185px' }}>
                  <div style={{ marginLeft: '10px' }}>
                    <StyledInput
                      dataTestId={`end-${row.id}`}
                      id={`end-${row.id}`}
                      inputDivider="left"
                      label={t('dealer-admin.ip-access.label.ipAddress')}
                      name={'end'}
                      placeholder={t('dealer-admin.ip-access.label.endingIP')}
                      onChange={(e: any) =>
                        handleIPInputChange(row, row.id, 'end', e.target.value)
                      }
                      maxLength={15}
                      isRequired={true}
                      value={row.end || ''}
                      hasCharacterCount={true}
                      enableCustomValidation
                      hasError={row.hasEndError}
                      errorMessage={row.endErrorMsg}
                      isDisabled={isDisabled}
                    />
                  </div>
                </td>
                <td style={{ width: '5px' }}>
                  <div style={{ marginBottom: '15px' }}>
                    {!isDisabled 
                      && <IconButton
                      icon={<IconRemove />}
                      size={BUTTON_SIZES.SMALL}
                      text="Button"
                      onClick={() => removeRow(row.id)}
                      data-testid={`remove-row-${row.id}`}
                    />
                    }
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllowedIpRangeComponent;
